var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-auto-complete',{staticStyle:{"width":"100%"},attrs:{"data-source":_vm.dataSource,"value":_vm.value,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"select":_vm.onSelect,"search":_vm.onSearch,"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }